export default __webpack_public_path__ + "static/media/Gauntlets of the Milites Templi.089f659e.jpg";